<template>
  <div class="note-list">
    <div class="list-container f-c">
      <div
        v-for="(row, i) in Array(noteSize)"
        :key="'note-row-' + i"
        class="note-row f-r"
        :class="{ 'last-row': i === noteSize - 1 }"
      >
        <div v-for="j in Two" :key="i + '-note-' + j" class="note f-r">
          <div class="left f-c-vc" v-if="i * 2 + j < notes.length">
            <svg-icon icon-class="note" class="note-icon" />
            <div class="line" />
          </div>
          <div class="right f-c" v-if="i * 2 + j < notes.length">
            <div
              class="note-content"
              :class="{
                important: getNote(i, j).status === NoteImportant
              }"
            >
              <div class="time">
                {{ getNoteCreatedTime(i, j) }}
              </div>
              <div
                class="content"
                :class="{
                  striked: getNote(i, j).status === NoteDeleted
                }"
              >
                {{ getNote(i, j).content }}
              </div>
            </div>
            <div class="status-buts f-r">
              <svg-icon
                icon-class="important"
                @click.native="() => changeStatus(i, j, NoteNormal)"
                v-if="getNote(i, j).status === NoteImportant"
              />
              <svg-icon
                icon-class="unimportant"
                @click.native="() => changeStatus(i, j, NoteImportant)"
                v-if="getNote(i, j).status === NoteNormal"
              />
              <svg-icon
                icon-class="trashed"
                @click.native="
                  () =>
                    changeStatus(
                      i,
                      j,
                      getNote(i, j).status === NoteDeleted
                        ? NoteNormal
                        : NoteDeleted
                    )
                "
                :class="{ deleted: getNote(i, j).status === NoteDeleted }"
              />
            </div>
          </div>
        </div>
      </div>
      <el-alert
        title="No note"
        type="warning"
        v-if="notes.length === 0"
        :closable="false"
      />
    </div>
  </div>
</template>
<script>
// models
import { NoteDeleted, NoteNormal, NoteImportant } from '@/core/models/note'
// components
export default {
  name: 'NoteList',
  props: {
    notes: {
      type: Array,
      required: true
    },
    changeCb: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      NoteDeleted,
      NoteNormal,
      NoteImportant,
      Two: [0, 1]
    }
  },
  computed: {
    noteSize() {
      return Math.ceil(this.notes.length / 2)
    }
  },
  methods: {
    getNote(i, j) {
      return this.notes[i * 2 + j]
    },
    getNoteCreatedTime(i, j) {
      const note = this.getNote(i, j)
      const date = new Date(note.createdTime)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    changeStatus(i, j, status) {
      if (this.disabled) return
      const note = this.getNote(i, j)
      note.status = status
      this.changeCb(this.notes)
    },
    noteValid(index) {
      return index < this.notes.length
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.note-list {
  margin-bottom: 20px;
  min-height: 400px;
}

.note {
  width: 100%;
  gap: 10px;
  align-items: stretch;

  .left {
    height: 100%;

    .note-icon {
      width: 20px;
      height: 20px;
      color: $el-primary-color;
    }

    .line {
      border: 1px solid #ccc;
      flex-grow: 1;
      height: calc(100% - 20px);
    }
  }

  .right {
    flex-grow: 1;
    gap: 5px;
    margin-bottom: 15px;

    &.last-row {
      margin-bottom: 0;
    }

    .note-content {
      background-color: rgba($color: $note-normal-color, $alpha: 1);
      border-radius: 8px;
      padding: $home-card-padding-y $home-card-padding-x;

      .time {
        font-size: 12px;
        margin-bottom: 5px;
      }

      .content {
        word-break: break-word;
      }
    }

    .status-buts {
      margin-left: 10px;
      gap: 5px;

      .svg-icon {
        padding: 3px;

        &:hover {
          cursor: pointer;
          background-color: rgba($color: $el-primary-color, $alpha: 0.1);
          border-radius: 4px;
        }
      }
    }
  }
}

.deleted {
  border-radius: 4px;
  background-color: rgba($color: $el-primary-color, $alpha: 0.1);
}

.striked {
  text-decoration: line-through;
}

.important {
  background-color: rgba($color: $el-danger-color, $alpha: 0.3) !important;
}

.list-container {
  margin-top: 10px;

  .note-row {
    align-items: stretch;
    gap: 20px;

    &.last-row ::v-deep .right {
      margin-bottom: 0;
    }
  }
}
</style>
